import React from 'react'
import {Grid,Box,Hidden} from '@mui/material'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import "react-responsive-carousel/lib/styles/ca"
import { Carousel } from 'react-responsive-carousel';
import FlightBooking from '../../assets/images/FlightBooking.jpg'
const Carousels = () => {
  return (
    // autoPlay infiniteLoop
    <Carousel autoPlay infiniteLoop  >
        {/* <Grid container spacing={2}>
            <Grid item lg={2}>
            <img src={FlightBooking} />
            </Grid>
            <Grid item xs={2}>
            <img src={FlightBooking} />
            </Grid>
            <Grid item xs={2}>
            <img src={FlightBooking} />
            </Grid>
            <Grid item xs={2}>
            <img src={FlightBooking} />
            </Grid>
            <Grid item xs={2}>
            <img src={FlightBooking} />
            </Grid>
            <Grid item xs={2}>
            <img src={FlightBooking} />
            </Grid>
        </Grid> */}
        {[0,1,2,3].map((i)=>{
            return <Grid container spacing={2} >
            <Grid item xs={12} lg={2}>
            <Box>
            <img src='https://www.marinersforex.com/img/GOA.jpg' />
           
            </Box>
            <Box style={{textAlign:'initial'}}>
            <span style={{color:'#343a40!important',fontWeight:'500 !important'}}>Goa,goa-India</span><br></br>
            <span style={{color:'#6c757d!important',fontWeight:'500 !important',fontSize:12}}>805 - Properties</span>
            </Box>
            </Grid>
           <Hidden only={['xs','sm']}>
           <Grid item  lg={2}>
            <img src='https://www.marinersforex.com/img/Mauritius.jpg' />
            <Box style={{textAlign:'initial'}}>
            <span style={{color:'#343a40!important',fontWeight:'500 !important'}}>Goa,goa-India</span><br></br>
            <span style={{color:'#6c757d!important',fontWeight:'500 !important',fontSize:12}}>805 - Properties</span>
            </Box>
            </Grid>
            <Grid item  lg={2}>
            <img src='https://www.marinersforex.com/img/GOA.jpg' />
            <Box style={{textAlign:'initial'}}>
            <span style={{color:'#343a40!important',fontWeight:'500 !important'}}>Goa,goa-India</span><br></br>
            <span style={{color:'#6c757d!important',fontWeight:'500 !important',fontSize:12}}>805 - Properties</span>
            </Box>
            </Grid>
            <Grid item  lg={2}>
            <img src='https://www.marinersforex.com/img/GOA.jpg' />
            <Box style={{textAlign:'initial'}}>
            <span style={{color:'#343a40!important',fontWeight:'500 !important'}}>Goa,goa-India</span><br></br>
            <span style={{color:'#6c757d!important',fontWeight:'500 !important',fontSize:12}}>805 - Properties</span>
            </Box>
            </Grid>
            <Grid item  lg={2}>
            <img src='https://www.marinersforex.com/img/GOA.jpg' />
            <Box style={{textAlign:'initial'}}>
            <span style={{color:'#343a40!important',fontWeight:'500 !important'}}>Goa,goa-India</span><br></br>
            <span style={{color:'#6c757d!important',fontWeight:'500 !important',fontSize:12}}>805 - Properties</span>
            </Box>
            </Grid>
            <Grid item  lg={2}>
            <img src='https://www.marinersforex.com/img/GOA.jpg' />
            <Box style={{textAlign:'initial'}}>
            <span style={{color:'#343a40!important',fontWeight:'500 !important'}}>Goa,goa-India</span><br></br>
            <span style={{color:'#6c757d!important',fontWeight:'500 !important',fontSize:12}}>805 - Properties</span>
            </Box>
            </Grid>
           </Hidden>
        </Grid>
        })}
               
            </Carousel>
  )
}

export default Carousels